import { render, staticRenderFns } from "./transfer-device.vue?vue&type=template&id=3b38546b&scoped=true"
import script from "./transfer-device.vue?vue&type=script&lang=js"
export * from "./transfer-device.vue?vue&type=script&lang=js"
import style0 from "./transfer-device.vue?vue&type=style&index=0&id=3b38546b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b38546b",
  null
  
)

export default component.exports